import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "button-group" }
const _hoisted_2 = { style: {"margin-bottom":"60px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "img-box" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  class: "pagination",
  style: {"margin-bottom":"200px"}
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

import { ref, onMounted,computed, watch } from 'vue';
import axios from '@/api/chart';
import type{YoutubeVideo} from '@/api/chart';
import YoutubeRankingSlider from '@/components/main/YoutubeRankingSlider.vue'
import FixedButtons from '@/components/main/FixedButtons.vue'
import CheckToday from '@/components/main/CheckToday.vue'

const itemsPerPage = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'YoutubeVideo',
  setup(__props) {

const videos = ref<YoutubeVideo[]>([]);
const fanVideos = ref<YoutubeVideo[]>([]);
const loading = ref(false);

const selectedVideo =ref<'all'|'fansign'>('all');

// 페이징처리

const currentPage = ref(1);
const totalPages = computed(() =>
  Math.ceil(displayedVideo.value.length / itemsPerPage)
)

const paginated = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  return displayedVideo.value.slice(start,start + itemsPerPage);
})

function goToPage(page:number){
  if(page >= 1 && page <= totalPages.value){
    currentPage.value = page;
    scrollToTop();
  }
}

watch(selectedVideo,() => {
  currentPage.value = 1;
})

async function fetchVideos() {
  loading.value = true;
  try {
    const res = await axios.getVideo()
    const fanres = await axios.getFanVideo()
    videos.value = res.data;
    fanVideos.value = fanres.data;
    console.log(videos.value);
  } catch (error) {
    console.error('영상 불러오기 실패', error);
  } finally {
    loading.value = false;
  }
}

function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  const koreaTime = new Date(date.getTime() + 9 * 60 * 60 * 1000);
  return koreaTime.toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hour12: false
  });
}



function formatNumber(num?: number): string {
  if (num === undefined) return '정보 없음';
  if (num >= 10_000) return `${(num / 10_000).toFixed(1)}만`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}천`;
  return num.toLocaleString('ko-KR');
}

const displayedVideo = computed(() => {
  return selectedVideo.value === 'all' ? videos.value : fanVideos.value;
})

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  fetchVideos();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "a-box" }, [
      _createElementVNode("a", { href: "/" }, " FIFTY페이지")
    ], -1)),
    _createVNode(YoutubeRankingSlider),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass({ active: selectedVideo.value === 'all' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedVideo.value = 'all'))
      }, " 피프티피프티 최신 영상 ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({ active: selectedVideo.value === 'fansign' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedVideo.value = 'fansign'))
      }, " 피프티피프티 팬싸 영상 ", 2)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("h4", { style: {"color":"red"} }, " * 해당 페이지는 비상업적 팬 페이지이며 서버비, 저작권 등 사유로 사라질 수 있으니 놀라지 마세요... ", -1)),
    _cache[6] || (_cache[6] = _createElementVNode("h4", { style: {"color":"black"} }, " * 영상은 9시, 13시, 19시, 00시 최신화 될 예정입니다. ", -1)),
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(selectedVideo.value === 'all' ? '피프티피프티 최신 영상' : '피프티피프티 팬싸 영상'), 1),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 로딩 중... "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginated.value, (video) => {
              return (_openBlock(), _createElementBlock("div", {
                key: video.videoId,
                class: "video-box"
              }, [
                _createElementVNode("section", _hoisted_5, [
                  _createElementVNode("a", {
                    href: `https://www.youtube.com/watch?v=${video.videoId}`,
                    target: "_blank"
                  }, [
                    _createElementVNode("img", {
                      class: "thmbnail-img",
                      src: video.thumbnailUrl,
                      alt: "썸네일"
                    }, null, 8, _hoisted_7)
                  ], 8, _hoisted_6)
                ]),
                _createElementVNode("section", _hoisted_8, [
                  _createElementVNode("a", {
                    style: {"margin-top":"10px"},
                    href: `https://www.youtube.com/watch?v=${video.videoId}`,
                    target: "_blank"
                  }, _toDisplayString(video.title), 9, _hoisted_9),
                  _createElementVNode("p", null, _toDisplayString(video.channelTitle), 1),
                  (selectedVideo.value !== 'fansign')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 구독자 " + _toDisplayString(formatNumber(video.subscriberCount)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, "조회수: " + _toDisplayString(formatNumber(video.viewCount)), 1),
                  _createElementVNode("p", null, " 업로드 날짜: " + _toDisplayString(formatDate(video.publishDate)), 1)
                ])
              ]))
            }), 128))
          ]))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        disabled: currentPage.value === 1,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(currentPage.value - 1)))
      }, " 이전 ", 8, _hoisted_12),
      _createElementVNode("span", null, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value), 1),
      _createElementVNode("button", {
        disabled: currentPage.value === totalPages.value,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage(currentPage.value +1 )))
      }, " 다음 ", 8, _hoisted_13)
    ]),
    _createVNode(FixedButtons, { onTop: scrollToTop }),
    _createVNode(CheckToday)
  ], 64))
}
}

})